import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import {
  hasNonZeroDashboardValues,
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { PatientStatusOverviewState } from '@hooks/dashboard/usePatientStatus'
import { OperationsPatientStatusChart } from '../OperationsPatientsCharts.component'

type PatientStatusCardProps = {
  titleHref: string
  chartData: PatientStatusOverviewState['chartData']
  axis: PatientStatusOverviewState['axis']
  loading: boolean
  hasPayload: boolean
}

export function PatientStatusCard({
  titleHref,
  chartData,
  axis,
  loading,
  hasPayload,
}: PatientStatusCardProps): React.ReactElement {
  const hasData = chartData.some((point) =>
    hasNonZeroDashboardValues(point.value),
  )
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Patient status"
      titleHref={titleHref}
      className="dashboard-operations-patients-card"
      loading={pending}
      skeleton={{ block: 'chart' }}
      isEmpty={isEmpty}
    >
      <OperationsPatientStatusChart data={chartData} axis={axis} />
    </DashboardSectionCard>
  )
}
